import { useContext } from 'react';
import { PublicContext } from '../contexts/PublicContext';

export const usePublicData = () => {
  const context = useContext(PublicContext);
  
  // Se não estiver no contexto público, retornar null para usar dados normais
  if (!context) {
    return {
      data: null,
      isLoading: false,
      error: null,
      isPublic: false
    };
  }

  const { isPublic, publicData, isLoading: publicLoading, error: publicError } = context;

  return {
    data: publicData,
    isLoading: publicLoading,
    error: publicError,
    isPublic: isPublic
  };
};
